import { render } from "./WebhooksFiltersDivider.vue?vue&type=template&id=671d3cf0&ts=true"
import script from "./WebhooksFiltersDivider.vue?vue&type=script&lang=ts"
export * from "./WebhooksFiltersDivider.vue?vue&type=script&lang=ts"

import "./WebhooksFiltersDivider.vue?vue&type=style&index=0&id=671d3cf0&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__